<!------------------------------------------------------------>
<!--------------------------- 注册页面 ------------------------>
<!------------------------------------------------------------>
<template>
    <div class="page">
        <div class="reg-back" @click="handleBackHome()">
            <img src="../../assets/images/future/fanhui.png" alt="">
            返回登录页
        </div>
        <div class="register flexBetween" id="register">
            <div id="regMask"></div>
            <div class="reg-content" @mouseenter="onGongyingshang()"
                @click="toGys">
                <img :src="gysImg" alt="我是供应商" class="img">
                <div class="reg-choose">选 择</div>
            </div>
            <div class="reg-content" @mouseenter="onShangjia()"
                @click="toSj">
                <img :src="sjImg" alt="我是商家" class="img">
                <div class="reg-choose">选 择</div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: 'future-register',
    data() {
        return {
            sjImg: require("../../assets/images/future/shangjia.png"),
            gysImg: require("../../assets/images/future/gongying2.png")
        }
    },
    methods: {
        onGongyingshang() {
            document.getElementById('regMask').style.left = '2%'
            this.gysImg = require("../../assets/images/future/gongying2.png")
            this.sjImg = require("../../assets/images/future/shangjia.png")
        },
        onShangjia() {
            document.getElementById('regMask').style.left = '52%';
            this.gysImg = require("../../assets/images/future/gongying.png")
            this.sjImg = require("../../assets/images/future/shangjia2.png")
        },

        handleBackHome() {
            this.$router.go(-1)
        },
        toGys(){
            window.location.href='https://web.tzfuture.cn/futureOpenplatform/register'
        },
        toSj(){
            window.location.href = 'https://web.tzfuture.cn/futureMerchant/register'
        }
    }
}
</script>
<style lang="less" scoped>
.page{
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    background-color: #1F5AD8;
}
.flexBetween {
    display: flex;
    justify-content: space-between;
}

.reg-back {
    position: absolute;
    top: 42px;
    left: 4%;
    z-index: 2;
    color: #ffffff;
    white-space: nowrap;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    img {
        margin-right: 12px;
    }
}


.register {
    position: absolute;
    top: 20vh;
    left: 50%;
    background-color: #fff;
    width: 60%;
    max-width: 1000px;
    height: 60vh;
    border-radius: 20px;
    transform: translateX(-50%);
}

.reg-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    cursor: pointer;
    position: relative;
    z-index: 3;
}

.reg-content img {
    max-height: 36vh;
    margin-bottom: 5vh;
    max-width: 80%;
}

.reg-choose {
    width: 50%;
    text-align: center;
    height: 44px;
    line-height: 44px;
    background: #0b70fb;
    border-radius: 8px;
    font-size: 18px;
    color: #ffffff;
    opacity: 0.5;
}

.reg-content:hover .reg-choose {
    opacity: 1;
}


#regMask {
    position: absolute;
    width: 46%;
    height: 90%;
    border-radius: 15px;
    background: rgba(11, 112, 251, 0.1);
    border: 1px solid rgba(11, 112, 251, 0.6);
    left: 2%;
    top: 5%;
    transition: all 0.4s linear;
}
</style>